// semeia-disable-reexport
import type ModelRegistry from "@ember-data/types/registries/model";
import { dasherize } from "@ember/string";

/**
 * Compute the `fields` parameter of a JSON API request, using a model and a list of model attributes.
 *
 * The `fields` parameter tells the API to return only those fields.
 * `fields` is a list of JSON API attributes, with words separated by a dash (eg. "firstName" is "first-name").
 *
 * This function transforms a list of model attributes into a list of JSON API attributes suitable for the `fields` parameter.
 */
export function apiFieldset<K extends keyof ModelRegistry>(
  model: K,
  attributes: Array<keyof ModelRegistry[K]>
): Record<string, string> {
  const type = `${dasherize(model)}s`;
  const fields = attributes
    .map(attribute => dasherize(attribute as string))
    .join(",");
  return { [type]: fields };
}
